module.exports = __webpack_public_path__ + "static/media/calendar.31f8f054.svg";